<template>
  <div id="Login" class="login fullheight" :class="{ 'c-dark-theme': $store.state.darkMode }"></div>
</template>
<script>
import login from '../../../services/login';
import store from '../../../store'
import axios from 'axios'

export default {
  name: 'AdminLoginLink',
  data: function () {
      return {
          code: '',
          email: '',
          password: '',
          password_2: '',
          image: '',
          user: false
      }
  },
  mounted: async function() {
    this.code = await this.$route.params.code;

    let params = {
      code: this.code
    };

    let response = await login.forceAdminLogin(params);

    localStorage.removeItem("token");
    localStorage.removeItem("is_administrator");
    localStorage.removeItem("is_customer");
    localStorage.removeItem("customer_id");
    localStorage.removeItem("is_collaborator");
    localStorage.removeItem("is_kam");

    if(response.type == "success"){
      let data = response.data;

      localStorage.setItem("token", data.access_token);

      axios.defaults.headers.common['access-token'] = data.access_token;
      axios.defaults.headers.common['api-token'] = data.access_token;

      localStorage.setItem("show_menu", data.is_administrator);

      localStorage.setItem("is_freelancer", "0");
      localStorage.setItem("freelancer_region", "");
      localStorage.setItem("force_login", "0");
      localStorage.setItem("admin_token", "");

      localStorage.setItem("is_administrator", data.is_administrator);
      localStorage.setItem("is_customer", data.is_customer);
      localStorage.setItem("customer_id", data.customer_id);
      localStorage.setItem("is_collaborator", data.is_collaborator);
      localStorage.setItem("is_kam", data.is_kam);
      localStorage.setItem("is_support", data.is_support);

      localStorage.removeItem("date");
      localStorage.removeItem("page");
      localStorage.removeItem("branch_id");
      localStorage.removeItem("visit_id");

      localStorage.removeItem("period");
      localStorage.removeItem("period_date");
      localStorage.removeItem("last_login");

      localStorage.removeItem("kam");
      localStorage.removeItem("customers");
      localStorage.removeItem("rutas");
      localStorage.removeItem("universos");
      localStorage.removeItem("generics");
    }
    
    window.location.replace("/#/freelancers");
    window.location.reload();
  },
  methods: {
    login: async function(){
      if(this.email == ""){
        alert("El correo electrónico es obligatorio.");
        return;
      }

      if(this.password == ""){
        alert("La contraseña es obligatoria.");
        return;
      }

      if(this.password != this.password_2){
        alert("Las contraseñas no coinciden.");
        return;
      }

      let params = {
        code: this.code,
        email: this.email,
        password: this.password,
        device_name: navigator.userAgent
      };

      let response = await login.loginByCode(params);

      if(response.type == "success"){
        let data = response.data;

        localStorage.setItem("domain", "demo");
        localStorage.setItem("token", data.api_token);
        localStorage.setItem("role", data.role);

        axios.defaults.headers.common['domain'] = "demo";
        axios.defaults.headers.common['api-token'] = data.api_token;
        
        if(response.data.role == "administrator"){
          window.location.href = "/#/home"; return;
        }
        else{
          if(response.data.role == "supplier"){
            window.location.href = "/#/freelance-visits/available"; return;
          }
          else{
            if(response.data.role == "manager"){
              window.location.href = "/#/freelance-visits/available"; return;
            }
            else{
              if(response.data.role == "kam"){
              window.location.href = "/#/home"; return;
            }
              else{
                window.location.href = "/#/404"; return;
              } 
            } 
          } 
        }
      }
      else{
        alert(response.message);
      }
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
